import type { Rarity } from './models/types';

/** The bubbly EthrHunt palette (same values as the Flutter theme). */
export const colors = {
  coral: '#FF6B6B',
  lime: '#B8F26B',
  sky: '#5CC8FF',
  lemon: '#FFE066',
  cream: '#FFF8F0',
  ink: '#2B2D42',
} as const;

export const rarityColors: Record<Rarity, string> = {
  common: '#7C8DB5',
  uncommon: '#3DCC7E',
  rare: '#3B8BFF',
  epic: '#A259FF',
  legendary: '#FFB800',
};

/** `#rrggbb` + alpha 0..1 -> `rgba(...)`. */
export function withAlpha(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  const n = Number.parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
